/* eslint-disable react/prop-types */
import React from 'react';

import { format } from 'date-fns';

import ptBR from 'date-fns/locale/pt-BR';

export default function DescricaoModal({
  tipoDeOperacao,
  modalData,
  modalDataResponsavel,
}) {
  return (
    <div className="data">
      {tipoDeOperacao === 'SUBMISSAO_DADOS' && (
        <>
          <div>
            <span>CNES</span>
            <p>{modalData && modalData.cnes}</p>
          </div>

          <div>
            <span>E-mail</span>
            <p>{modalData && modalData.email}</p>
          </div>

          <div>
            <span>Período</span>
            <p>{modalData && modalData.periodo}</p>
          </div>
        </>
      )}

      {tipoDeOperacao === 'CADASTRO_USUARIO' && (
        <>
          <div>
            <span>Nome</span>
            <p>{modalData && modalData.nome}</p>
          </div>

          <div>
            <span>CPF</span>
            <p>{modalData && modalData.cpf}</p>
          </div>

          <div>
            <span>E-mail</span>
            <p>{modalData && modalData.email}</p>
          </div>

          <div>
            <span>Telefone</span>
            <p>{modalData && modalData.telefone}</p>
          </div>

          <div>
            <span>Cargo</span>
            <p>{modalData && modalData.cargo}</p>
          </div>

          <div>
            <span>Situação</span>
            <p>{modalData && modalData.ativo ? 'Ativo' : 'Inativo'}</p>
          </div>

          <div>
            <span>Data de criação</span>
            <p>
              {modalData &&
                modalData.dataCriacao &&
                format(
                  new Date(`${modalData.dataCriacao}`),
                  'dd/MM/yyyy - HH:mm:ss',
                  {
                    locale: ptBR,
                  }
                )}
            </p>
          </div>
        </>
      )}

      {tipoDeOperacao === 'ATUALIZACAO_PERFIL' && (
        <>
          {modalData && modalData.cnes && (
            <div>
              <span>CNES</span>
              <p>{modalData.cnes}</p>
            </div>
          )}

          {modalDataResponsavel && modalDataResponsavel.nomeFantasia && (
            <div>
              <span>Instituição</span>
              <p>{modalDataResponsavel.nomeFantasia}</p>
            </div>
          )}

          {modalData && modalData.dataCriacao && (
            <div>
              <span>Data</span>

              <p>
                {format(
                  new Date(`${modalData.dataCriacao}`),
                  'dd/MM/yyyy - HH:mm:ss',
                  {
                    locale: ptBR,
                  }
                ) || ''}
              </p>
            </div>
          )}

          {modalDataResponsavel && modalDataResponsavel.nomeUsuario && (
            <div>
              <span>Responsável</span>
              <p>{modalDataResponsavel.nomeUsuario}</p>
            </div>
          )}
          {modalDataResponsavel && modalDataResponsavel.email && (
            <div>
              <span>E-mail do responsável</span>
              <p>{modalDataResponsavel.email}</p>
            </div>
          )}
        </>
      )}

      {tipoDeOperacao === 'REABIR_COMPETENCIA' && (
        <>
          <div>
            <span>Período</span>
            <p>{modalData && modalData.periodo}</p>
          </div>

          <div>
            <span>Responsável</span>
            <p>{modalData && modalDataResponsavel.nomeUsuario}</p>
          </div>

          <div>
            <span>E-mail</span>
            <p>{modalData && modalDataResponsavel.email}</p>
          </div>

          <div>
            <span>Instituição</span>
            <p>{modalData && modalDataResponsavel.nomeFantasia}</p>
          </div>

          <div>
            <span>Data</span>
            <p>
              {modalData &&
                modalDataResponsavel.dataCriacao &&
                format(
                  new Date(`${modalDataResponsavel.dataCriacao}`),
                  'dd/MM/yyyy - HH:mm:ss',
                  {
                    locale: ptBR,
                  }
                )}
            </p>
          </div>
        </>
      )}

      {tipoDeOperacao === 'ATUALIZAO_SUPORTE' && (
        <>
          {modalData && modalData.extensao && (
            <div>
              <span>Nome do arquivo</span>
              <p>{modalData.nome || ''}</p>
            </div>
          )}

          {modalData && modalData.extensao && (
            <>
              <div>
                <span>Extensão</span>
                <p>.{modalData.extensao || ''}</p>
              </div>

              <div>
                <span>Tipo</span>
                <p>
                  {modalData &&
                    (modalData.tipo === 'FILE'
                      ? 'Arquivo'
                      : 'Link externo' || '')}
                </p>
              </div>
            </>
          )}

          <div>
            <span>Instituição</span>
            <p>{modalData && (modalDataResponsavel.nomeFantasia || '')}</p>
          </div>

          <div>
            <span>Responsável</span>
            <p>{modalData && (modalDataResponsavel.nomeUsuario || '')}</p>
          </div>

          {modalData && modalData.dataInsercao && (
            <div>
              <span>Data</span>
              <p>
                {format(
                  new Date(`${modalData.dataInsercao}`),
                  'dd/MM/yyyy - HH:mm:ss',
                  {
                    locale: ptBR,
                  }
                ) || ''}
              </p>
            </div>
          )}
        </>
      )}

      {tipoDeOperacao === 'ADICAO_LINHA_CUIDADO' && (
        <>
          <div>
            <span>CNES</span>
            <p>{modalData && modalData.cnes}</p>
          </div>

          <div>
            <span>Instituição</span>
            <p>{modalData && modalData.fantasyName}</p>
          </div>
          <div>
            <span>Responsável</span>
            <p>{modalData && modalDataResponsavel.nomeUsuario}</p>
          </div>

          <div>
            <span>E-mail</span>
            <p>{modalData && modalDataResponsavel.email}</p>
          </div>
        </>
      )}

      {tipoDeOperacao === 'CADASTRO_INSTITUICAO' && (
        <>
          <div>
            <span>CNES</span>
            <p>{modalData && modalData.cnes}</p>
          </div>

          <div>
            <span>Instituição</span>
            <p>{modalData && modalData.nomeFantasia}</p>
          </div>

          <div>
            <span>Cidade</span>
            <p>{modalData && modalData.cidade}</p>
          </div>

          <div>
            <span>Estado</span>
            <p>{modalData && modalData.estado}</p>
          </div>

          <div>
            <span>CNPJ</span>
            <p>{modalData && modalData.cnpj}</p>
          </div>

          <div>
            <span>Telefone</span>
            <p>{modalData && modalData.telefone}</p>
          </div>

          <div>
            <span>Situação</span>
            <p>{modalData && modalData.ativo ? 'Ativa' : 'Inativa'}</p>
          </div>

          <div>
            <span>Endereço</span>
            <p>{modalData && modalData.address}</p>
          </div>

          <div>
            <span>CEP</span>
            <p>{modalData && modalData.cep}</p>
          </div>

          <div>
            <span>Número</span>
            <p>{modalData && modalData.numero}</p>
          </div>

          <div>
            <span>Responsável</span>
            <p>{modalData && modalDataResponsavel.nomeUsuario}</p>
          </div>

          <div>
            <span>E-mail</span>
            <p>{modalData && modalDataResponsavel.email}</p>
          </div>
        </>
      )}

      {tipoDeOperacao === 'EXPORTACAO_DADOS' && (
        <>
          <div>
            <span>CNES</span>
            <p>{modalData && modalData.cnes}</p>
          </div>

          <div>
            <span>E-mail do responsável</span>
            <p>{modalDataResponsavel && modalDataResponsavel.email}</p>
          </div>

          <div>
            <span>Data e hora do evento</span>
            <p>
              {(modalDataResponsavel &&
                format(
                  new Date(`${modalDataResponsavel.dataCriacao}`),
                  'dd/MM/yyyy - HH:mm:ss',
                  {
                    locale: ptBR,
                  }
                )) ||
                ''}{' '}
            </p>
          </div>

          <div>
            <span>Linha de Cuidado</span>
            <p>{modalData && modalData.nomeLinhaCuidado}</p>
          </div>

          <div>
            <span>Período</span>
            <p>{modalData && modalData.periodo}</p>
          </div>
        </>
      )}
    </div>
  );
}
